/**
 * Entry point for the media settings options page.
 */ import { jsx as _jsx } from "react/jsx-runtime";
import "@devowl-wp/utils/antd.scss";
import $ from "jquery";
import { createRoot } from "react-dom/client";
import { ready } from "@devowl-wp/react-utils";
import { handleCorruptRestApi } from "@devowl-wp/utils";
import { Provider } from "./components/common/provider.js";
import { OptionsPage } from "./components/options/optionsPage.js";
import { bindOptionsRestButtons, optionsScreen } from "./integrations/optionsScreen.js";
import { RootStore } from "./store/rootStore.js";
import { request } from "./utils/request.js";
handleCorruptRestApi({
    "realmedialibrary/v1": async ()=>{
        await request({
            location: {
                path: "/plugin"
            }
        });
    }
});
const node = document.getElementById(`${RootStore.get.optionStore.slug}-component`);
ready(()=>{
    if ($("body").hasClass("options-media-php")) {
        optionsScreen();
        bindOptionsRestButtons();
    }
    if (node) {
        createRoot(node).render(/*#__PURE__*/ _jsx(Provider, {
            children: /*#__PURE__*/ _jsx(OptionsPage, {})
        }));
    }
});
export * from "@devowl-wp/utils";
export * from "./wp-api/index.js";
export * from "./store/storedAppTree.js";
